module.exports = __webpack_public_path__ + "static/media/1_A1_19.91c7c7f9.png";